import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootMark = (window as any).__oeBootMark;
if (typeof bootMark === 'function') {
  bootMark('mainjs');
}
try {
  sessionStorage.removeItem('oe_js_reload');
} catch (e) { }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    if (typeof bootMark === 'function') {
      const msg = err && (err.message || String(err));
      const stackLine = err && err.stack ? String(err.stack).split('\n')[1] : '';
      bootMark('ngfail', (msg + ' ' + (stackLine || '')).trim());
    }
    console.error(err);
  });
